<template>
    <select-label
        v-model="item"
        :disabled="isDisabled"
        :editable="isEditable"
        :items="itemListWithEmpty"
        :append-icon="isDisabled ? '' : '$vuetify.icons.dropdown'"
        item-text="text"
        item-value="value"
        :label="label"
    />
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import SelectLabel from './SelectLabel.vue';

@Component({
    name: 'SelectorFilterItems',
    components: {
        SelectLabel,
    },
})
export default class SelectorFilterItems extends Vue {
    @Prop({ type: [String, Number], default: '' }) value: string | number;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: true }) editable: boolean;
    @Prop({ default: undefined }) label: string;
    @Prop({ default: () => [{}] }) itemList: Array<{ text_key: string; value: string | number }>;
    @Emit()
    public input(value: string | number) {}

    get isDisabled(): boolean {
        return this.disabled;
    }
    get isEditable(): boolean {
        return this.editable;
    }
    get item(): string | number {
        return this.value;
    }
    set item(newVal: string | number) {
        this.input(newVal);
    }
    get itemListWithEmpty(): Array<{ text: string; value: string | number }> {
        return [
            { text: '', value: '' },
            ...this.itemList.map(kv => {
                return { text: (this as any).$t(kv.text_key), value: kv.value };
            }),
        ];
    }
}
</script>
